import { FunctionComponent } from 'react'
import Button from '~/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { Modal } from '~/components/Modal'

type ChangePrioritiesModalProps = {
  onValidate: () => void
}

export const ChangePrioritiesModal: FunctionComponent<ChangePrioritiesModalProps> = ({ onValidate }) => {
  const { close } = useGlobalModal()
  return (
    <Modal.Content>
      <Modal.Title>Validate priority changes</Modal.Title>

      <Modal.Body>
        <div>
          Changing stacks priorities can have a <strong>significative impact</strong> on your monetization.
        </div>
        <div> Are you sure you want to deploy the new configuration?</div>
      </Modal.Body>

      <Modal.Actions>
        <Button variant={'tertiary'} onClick={close} trackingLabel={'adm-sites-stack-priorities-save-cancel'}>
          Cancel
        </Button>
        <Button variant={'primary'} onClick={onValidate} trackingLabel={'adm-sites-stack-priorities-save-confirm'}>
          Deploy
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}
